module.exports = __webpack_public_path__ + "static/media/back-fuchsia.e553af95.png";